// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { Box, SxProps, Theme, Typography } from "@outschool/backpack";
import React from "react";

type FilterListProps = {
  children: React.ReactNode;
  sx?: SxProps;
};

export const FilterList = React.forwardRef<typeof Box, FilterListProps>(
  ({ children, sx = {} }, ref) => {
    return (
      <Box
        ref={ref}
        sx={[
          (theme: Theme) => ({
            display: "grid",
            gridTemplateColumns: "1fr",
            gridGap: "2em",
            fontSize: "1.3em",

            [theme.breakpoints.up("sm")]: {
              fontSize: "inherit",
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Box>
    );
  }
);

export function Filter({
  title,
  sx,
  innerSx,
  children,
  titleSx,
}: {
  title?: string | null;
  sx?: SxProps;
  innerSx?: SxProps;
  titleSx?: SxProps;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={[
        {
          display: "grid",
          gridTemplateColumns: "1fr",
          gridGap: "0.5em",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {title && (
        <Typography
          variant="h3"
          sx={[
            {
              fontSize: "1.2em !important",
            },
            ...(Array.isArray(titleSx) ? titleSx : [titleSx]),
          ]}
        >
          {title}
        </Typography>
      )}
      <Box sx={innerSx}>{children}</Box>
    </Box>
  );
}
